export type LayoutCollectionState = 'loading' | 'error' | 'empty' | 'ready';

interface LayoutCollectionStateInput {
  isLoading: boolean;
  error: unknown;
  layoutCount: number;
}

/**
 * Keep failed layout requests distinct from successful empty responses. An
 * error takes precedence even though TanStack Query exposes no data as an
 * empty fallback while the failed request is being handled.
 */
export const getLayoutCollectionState = ({
  isLoading,
  error,
  layoutCount,
}: LayoutCollectionStateInput): LayoutCollectionState => {
  if (error) return 'error';
  if (isLoading) return 'loading';
  if (layoutCount === 0) return 'empty';
  return 'ready';
};
